"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoteImage = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./RemoteImage.css");
var _cdsCommon = require("@cbhq/cds-common");
var _useShapeToBorderRadiusSize = require("@cbhq/cds-common/hooks/useShapeToBorderRadiusSize");
var _useAvatarSize = require("@cbhq/cds-common/media/useAvatarSize");
var _getRemoteImageWidthAndHeight = require("@cbhq/cds-common/utils/getRemoteImageWidthAndHeight");
var _useRemoteImageSrc = require("../hooks/useRemoteImageSrc");
var _tokens = require("../tokens");
var _linaria = require("../utils/linaria");
const _excluded = ["width", "height", "aspectRatio", "shape", "source", "alt", "className", "resizeMode", "testID", "size", "borderColor"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const resizeModes = {
  cover: "cds-cover-c180dv6t",
  contain: "cds-contain-c1un2i4r"
};
const image = "cds-image-iatoufh";
const hexagonOverflowClass = "cds-hexagonOverflowClass-h1o2pnk7";
const imageRatio = "cds-imageRatio-i1uoeyag";
const RemoteImage = /*#__PURE__*/(0, _react.memo)(function RemoteImage(_ref) {
  let width = _ref.width,
    height = _ref.height,
    aspectRatio = _ref.aspectRatio,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'square' : _ref$shape,
    source = _ref.source,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    className = _ref.className,
    _ref$resizeMode = _ref.resizeMode,
    resizeMode = _ref$resizeMode === void 0 ? 'cover' : _ref$resizeMode,
    testID = _ref.testID,
    size = _ref.size,
    borderColor = _ref.borderColor,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const borderRadius = (0, _useShapeToBorderRadiusSize.useShapeToBorderRadiusSize)(shape);
  const avatarSize = (0, _useAvatarSize.useAvatarSize)(size !== null && size !== void 0 ? size : 'm');
  const spectrum = (0, _cdsCommon.useSpectrum)();
  const imageSrc = (0, _useRemoteImageSrc.useRemoteImageSrc)(spectrum, source);
  const _getRemoteImageWidthA = (0, _getRemoteImageWidthAndHeight.getRemoteImageWidthAndHeight)({
      size,
      width,
      height,
      avatarSize
    }),
    finalWidth = _getRemoteImageWidthA.width,
    finalHeight = _getRemoteImageWidthA.height;
  const styles = (0, _react.useMemo)(() => ({
    borderRadius,
    '--image-aspect-ratio': aspectRatio ? aspectRatio.join(' / ') : undefined,
    border: borderColor ? `2px solid ${_tokens.palette[borderColor]}` : undefined
  }), [aspectRatio, borderColor, borderRadius]);
  const imageOverflow = (0, _react.useMemo)(() => shape === 'hexagon' && hexagonOverflowClass, [shape]);
  return /*#__PURE__*/_react.default.createElement("img", _extends({
    alt: alt,
    "data-testid": testID
  }, props, {
    className: (0, _linaria.cx)(image, imageOverflow, aspectRatio && imageRatio, resizeModes[resizeMode], className),
    height: finalHeight,
    src: imageSrc,
    style: styles,
    width: finalWidth
  }));
});
exports.RemoteImage = RemoteImage;